import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo, useState, useCallback } from "react";
import { Formik, Form, Field, useFormikContext } from "formik";
import { useIntl, defineMessages } from "react-intl";
import { Grid, FormControl, FormHelperText, makeStyles } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import { TextField, KeyboardDatePickerField, SelectField } from "@ploy-ui/form-fields";
import { PendingButton } from "@ploy-ui/core";
import { object, string } from "yup";
import { ApplicationStatusId } from "@ploy-lib/types";
import { Edit as EditIcon } from "@material-ui/icons/";
import { AddDriver } from "./CarOrderAddDriver";
import { legacyApiResourceUrl } from "@ploy-lib/core";
const messages = defineMessages({
    invalidDate: {
        id: "form_fields.datetimepicker.missing",
        defaultMessage: "Date is missing",
        description: "text for missing date"
    },
    invalidCarProdNumber: {
        id: "form_fields.carProdNumber.missing",
        defaultMessage: "Missing Order Number",
        description: "text for missing production number"
    },
    invalidRegnr: {
        id: "form_fields.carRegNr.missing",
        defaultMessage: "Reg.nr. is invalid",
        description: "registration number is invalid"
    }
});
const useStyles = makeStyles({
    editButton: {
        marginLeft: "-1em"
    }
});
const CarOrderActions = (props) => {
    const { loadedData, reload, rowData, reloadData } = props;
    const intl = useIntl();
    const [addDriver, setAddDriver] = useState(false);
    const classes = useStyles();
    const CarOrderSchema = useMemo(() => object().shape({
        deliveryDate: string().required(intl.formatMessage(messages.invalidDate)),
        carProdNr: string().ensure()
    }), [intl]);
    const CarRegSchema = useMemo(() => object().shape({
        regNr: string()
            .required(intl.formatMessage(messages.invalidRegnr))
            .matches(/^([A-Z]{2})([0-9]{5})$/)
    }), [intl]);
    const addDriverButton = useCallback(() => {
        setAddDriver(!addDriver);
    }, [addDriver]);
    const submitCarOrder = useCallback(async (data, formik) => {
        await onConfirm(data, formik);
        await reload?.();
        await reloadData?.({ applicationId: rowData.applicationId });
    }, [rowData, reloadData, reload]);
    const submitRegNr = useCallback(async (data, formik) => {
        await onConfirmRegNr(data, formik);
        await reload?.();
        await reloadData?.({ applicationId: rowData.applicationId });
    }, [reload, rowData, reloadData]);
    if (!loadedData)
        return null;
    if (addDriver)
        return (_jsx(AddDriver, { loadedData: loadedData, addDriver: addDriverButton, reloadData: reloadData }));
    return (_jsxs("div", { children: [_jsx(Formik, { initialValues: {
                    deliveryDate: loadedData.deliveryDate,
                    carProdNr: loadedData.car.ordNr,
                    selectedDriver: loadedData.selectedDriver,
                    applicationId: loadedData.applicationId
                }, onSubmit: submitCarOrder, validationSchema: CarOrderSchema, validateOnMount: true, enableReinitialize: true, children: ({ isSubmitting, status = {} }) => (_jsx(Form, { children: _jsxs(Grid, { container: true, spacing: 2, alignItems: "flex-end", children: [loadedData.avaiableDrivers.length >= 1 && (_jsx(Grid, { item: true, xs: 12, md: 6, lg: 3, children: _jsx(Field, { name: "selectedDriver", label: _jsx(FormattedMessage, { id: "dealer.driver", description: "text for driver", defaultMessage: "Driver" }), variant: "outlined", helperText: " ", items: loadedData.avaiableDrivers, getItemValue: (item) => item?.["salepersonId"] ?? item, getItemLabel: (item) => item?.["fullName"] ?? item, component: SelectField, disabled: isSubmitting || loadedData.disableSendOrderSection, margin: "normal", fullWidth: true }) })), !loadedData.disableSendOrderSection ? (_jsx(Grid, { item: true, children: _jsxs(FormControl, { variant: "standard", margin: "normal", children: [_jsx(PendingButton, { className: classes.editButton, type: "button", size: "large", onClick: addDriverButton, children: _jsx(EditIcon, {}) }), _jsx(FormHelperText, { color: status && status.success ? "inherit" : "error", children: "" })] }) })) : null, _jsx(Grid, { item: true, xs: 12, md: 6, lg: 3, children: _jsx(Field, { name: "deliveryDate", label: _jsx(FormattedMessage, { id: "dealer.delivery.date", description: "text for deliverydate", defaultMessage: "Delivery date" }), component: KeyboardDatePickerField, disabled: isSubmitting || loadedData.disableSendOrderSection, margin: "normal", variant: "outlined", helperText: " ", fullWidth: true, autoOk: true, allowKeyboardControl: true, format: "long" }) }), _jsx(Grid, { item: true, xs: 12, md: 6, lg: 3, children: _jsx(Field, { name: "carProdNr", label: _jsx(FormattedMessage, { id: "dealer.production.number", description: "text for productionnumber", defaultMessage: "Order number" }), component: TextField, disabled: isSubmitting ||
                                        (loadedData.car.ordNr !== "" &&
                                            loadedData.car.ordNr !== undefined &&
                                            loadedData.car.ordNr !== null) ||
                                        loadedData.disableSendOrderSection, margin: "normal", variant: "outlined", helperText: " ", fullWidth: true }) }), !loadedData.disableSendOrderSection ? (_jsx(Grid, { item: true, xs: 12, md: 4, lg: 3, children: _jsxs(FormControl, { variant: "standard", margin: "normal", fullWidth: true, children: [_jsx(SubmitButton, { type: "button", variant: "contained", color: "secondary", size: "large", fullWidth: true, children: "Bekreft bilbestilling" }), _jsx(FormHelperText, { color: status.success && !status.error ? "inherit" : "error", children: status.error || status.message || " " })] }) })) : null] }) })) }), loadedData.disableSendOrderSection ? (_jsx("h3", { children: rowData.applicationStatusId === ApplicationStatusId.Paid
                    ? "Bilbestilling er sendt"
                    : loadedData.carOrderConfirmed
                        ? `Bilbestilling er sendt den ${loadedData.confirmDate} av ${loadedData.confirmUser}`
                        : null })) : null, _jsx(Formik, { initialValues: {
                    regNr: rowData.field8 || "",
                    applicationId: rowData.applicationId || ""
                }, onSubmit: submitRegNr, validationSchema: CarRegSchema, children: ({ status = {}, isSubmitting }) => (_jsx(Form, { children: _jsxs(Grid, { container: true, spacing: 2, alignItems: "flex-end", children: [_jsx(Grid, { item: true, xs: 12, md: 6, lg: 3, children: _jsx(Field, { name: "regNr", label: _jsx(FormattedMessage, { id: "dealer.production.regNr", description: "text for registrationnumber", defaultMessage: "Registration number" }), component: TextField, disabled: isSubmitting || loadedData.disableEditRegNumberButton, margin: "normal", variant: "outlined", helperText: " ", fullWidth: true }) }), !loadedData.disableEditRegNumberButton ? (_jsx(Grid, { item: true, xs: 12, md: 4, lg: 3, children: _jsxs(FormControl, { variant: "standard", margin: "normal", fullWidth: true, children: [_jsx(SubmitButtonRegNR, { type: "button", variant: "contained", color: "secondary", size: "large", fullWidth: true, children: "Endre regnr" }), _jsx(FormHelperText, { color: status.success && !status.error ? "inherit" : "error", children: status.error || status.message || " " })] }) })) : (_jsx(_Fragment, {}))] }) })) })] }));
};
const onConfirm = async (data, formik) => {
    const response = await fetch(legacyApiResourceUrl("CarOrder/Confirm"), {
        method: "POST",
        body: new Blob([JSON.stringify(data)], { type: "application/json" }),
        headers: {
            accept: "application/json"
        }
    });
    if (response.ok) {
        formik.setSubmitting(false);
    }
    else {
        formik.setStatus({ error: "" });
    }
};
const onConfirmRegNr = async (data, formik) => {
    const response = await fetch(legacyApiResourceUrl("CarOrder/ChangeRegistrationNumber"), {
        method: "POST",
        body: new Blob([JSON.stringify(data)], { type: "application/json" }),
        headers: {
            accept: "application/json"
        }
    });
    if (response.ok) {
        formik.setSubmitting(false);
    }
    else {
        formik.setStatus({ error: "" });
    }
};
export function SubmitButton(props) {
    const formik = useFormikContext();
    return (_jsx(PendingButton, { pending: formik.isSubmitting, disabled: !formik.isValid, onClick: () => {
            if (window.confirm("Er du sikker på bilbestillingen?"))
                formik.submitForm();
        }, ...props }));
}
export function SubmitButtonRegNR(props) {
    const formik = useFormikContext();
    return (_jsx(PendingButton, { pending: formik.isSubmitting, disabled: !formik.isValid, onClick: () => {
            if (window.confirm("Er du sikker du ønsker å endre regnr?"))
                formik.submitForm();
        }, ...props }));
}
export default CarOrderActions;
//# sourceMappingURL=CarOrderActions.js.map